import { useEffect } from 'react';
import { useMobileLayout } from './useMobileLayout';
import { appNavigate } from '../utils/appNavigate';
import {
  desktopPathFromMobileField,
  isMobileFieldPath,
} from '../utils/mobileFieldPaths';

/**
 * Keeps `/m/*` routes and desktop inventory routes in sync with viewport width.
 * Narrow → desktop list routes redirect to field mode (see InsightApp).
 * Wide → field mode routes redirect back to desktop equivalents.
 */
export function useMobileFieldViewportSync(
  cleanPath: string,
  subdomain: string | null,
  enabled: boolean,
): boolean {
  const isMobileLayout = useMobileLayout();
  const onMobileFieldPath = isMobileFieldPath(cleanPath);
  const pendingDesktopEscape = enabled && !isMobileLayout && onMobileFieldPath;

  useEffect(() => {
    if (!pendingDesktopEscape) {
      return;
    }
    const desktopPath = desktopPathFromMobileField(cleanPath, window.location.search);
    if (!desktopPath) {
      const prefix = subdomain ? `/${subdomain}` : '';
      appNavigate(`${prefix}/containers`);
      return;
    }
    const prefix = subdomain ? `/${subdomain}` : '';
    appNavigate(`${prefix}${desktopPath}`);
  }, [pendingDesktopEscape, cleanPath, subdomain]);

  return pendingDesktopEscape;
}
